var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandMiddleFinger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 240C390.848 240 382.385 242.697 375.107 247.139C370.943 224.869 351.48 208 328 208C311.281 208 296.594 216.561 288 229.52V40C288 17.906 270.094 0 248 0S208 17.906 208 40V240C208 213.484 186.516 192 160 192S112 213.484 112 240V336C112 344.836 104.836 352 96 352S80 344.836 80 336V290.527L50.016 314.516C38.629 323.626 32 337.418 32 352V400.025C32 410.401 35.366 420.497 41.594 428.797L56.021 448.025C86.239 488.299 133.652 512 184.002 512H320C390.692 512 448 454.692 448 384V288C448 261.484 426.516 240 400 240Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandMiddleFinger);
export default __webpack_public_path__ + "static/media/hand-middle-finger.56322b4fd680e5bd2adebbaea82d7c7b.svg";
export { ForwardRef as ReactComponent };